import { Injectable } from '@angular/core';
import {ServerService} from "./ServerService";
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CartaoClienteService extends ServerService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  obtenhaCartoes(opcoes: any = {}) {
    return this.obtenha('/cartao-cliente', opcoes);
  }

  obtenhaCartao(id: number) {
    return this.obtenha(`/cartao-cliente/${id}`, {});
  }

  insiraCartao(cartao: any) {
    return this.facaPost('/cartao-cliente', cartao);
  }

  atualizeCartao(cartao: any) {
    return this.facaPut(`/cartao-cliente/${cartao.id}`, cartao);
  }

  removaCartao(id: number) {
    return super.remova(`/cartao-cliente/${id}`, {id: id});
  }

  gereLoteCartoes(quantidade: number) {
    return this.facaPost('/cartao-cliente/gerar-lote', { quantidade });
  }

  crieCartao(cartao: any): Promise<any> {
    const dadosParaEnvio: any = {
      codigo: cartao.codigo,
      codigoPdv: cartao.codigoPdv,
      ativo: cartao.ativo
    };

    return this.http.post(`/cartao-cliente`, dadosParaEnvio)
      .toPromise();
  }
}
